import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const InvoicePreviewDialog = ({ open, onClose, html }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <div style={{ position: 'absolute', right: 8, top: 8 }}>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
    <iframe
      srcDoc={html}
      title="Invoice Preview"
      width="100%"
      height="700px"
      style={{ border: 'none', marginTop: 0 }}
    />
  </Dialog>
);

export default InvoicePreviewDialog;